import { GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getRowId } from 'routes/secondary-market-batch/grid/components';
import { SelectedRow, secondaryMarketBatchActions } from 'state/workspaces/secondary-market/batch/actions';
import { RowData } from 'state/workspaces/secondary-market/batch/model';
import { selectRowsByOrderType } from 'state/workspaces/secondary-market/batch/selectors';

export const useSelection = (orderType: OrderType, api?: GridApi) => {
  const dispatch = useDispatch();
  const rows = useAppSelector(state => selectRowsByOrderType(state, orderType));
  const handleSelectionChanged = useCallback(
    (e: SelectionChangedEvent<RowData>) => {
      const rows: SelectedRow[] = [];
      e.api.forEachNode(n => {
        if (n.data) {
          rows.push({ id: n.data.rowId, selected: n.isSelected() ?? false });
        }
      });
      dispatch(secondaryMarketBatchActions.selectedRowsChanged(orderType, rows));
    },
    [dispatch, orderType],
  );

  useEffect(() => {
    if (!api) {
      return;
    }
    api.forEachNode(n => {
      const row = rows.find(r => getRowId(r.data) === getRowId(n.data));
      if (row && n.isSelected() !== row.selected) {
        n.setSelected(row.selected, false, 'api');
      }
    });
  }, [api, rows]);

  return { handleSelectionChanged };
};
